import "./App.scss";
import React, { Suspense, useEffect } from "react";
import LoadingIndicator from "./utils/LoadingIndicator";
import { Routes, Route, Navigate } from "react-router-dom";
import { BasicRoutesConfig } from "./routes/Routes";
import Layout from "./Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { rolesConfig } from "../src/routes/Routes";
import {
  CLIENT_ADMINISTRATOR,
  SYSTEM_ADMINISTRATOR,
} from "./utils/constants";
import { setSentOtpSuccessFul } from "./redux/ducks/auth";
import formbricks from "@formbricks/js";

export default function App() {
  const { isAuthenticated, userRole, isAuthLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  let routes;
  if (isAuthenticated) {
    if (userRole === CLIENT_ADMINISTRATOR) {
      routes = rolesConfig["Org_Admin"];
    } else if (userRole === SYSTEM_ADMINISTRATOR) {
      routes = rolesConfig["System_Admin"];
    } else {
      routes = rolesConfig["User"];
    }
  }

  // FIX: on every refresh, index.js dispatches getUserDetailsByToken()
  // to verify the session — but that's an async network call. This
  // component was rendering (and redirecting to "/") on the very FIRST
  // render, before that check had any chance to complete — meaning any
  // authenticated user got bounced to login/home on every single
  // refresh, regardless of their actual real page.
  //
  // hasSessionToken guards against ever getting stuck loading forever:
  // if there's genuinely no token to check, skip straight to the
  // existing "not authenticated" behavior immediately, same as before.
  const hasSessionToken = !!sessionStorage.getItem("loginToken");
  const isCheckingAuth = hasSessionToken && !isAuthenticated && isAuthLoading;

  if (typeof window !== "undefined") {
    formbricks.init({
      environmentId: "cm6z5l9n50002l503jhhsysm6", 
      apiHost: "https://app.formbricks.com",
    });
  } else {
    console.error("Window object not accessible to init Formbricks");
  }
  
  useEffect(() => {
    // updated the state so after the login when the code is xpired it woun't go to the otp page
    if (isAuthenticated) {
      dispatch(setSentOtpSuccessFul(""));
    }
  }, [isAuthenticated]);
  return (
    <>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          {BasicRoutesConfig.map((route, key) => {
            return route ? <Route key={key} {...route} /> : null;
          })}

          {isCheckingAuth ? (
            <Route path="/*" element={<LoadingIndicator />} />
          ) : isAuthenticated ? (
            <Route element={<Layout />}>
              {routes.routes.map((route, key) => {
                return route ? <Route key={key} {...route} /> : null;
              })}
            </Route>
          ) : (
            <Route path="/*" element={<Navigate to="/" replace />} />
          )}
        </Routes>
      </Suspense>
    </>
  );
}